import { useState, useEffect } from "react"; 
import "../styles/JobApplicationForm.css";

const API_URL = "https://backend.afrivisionconsultants.com";
// const API = "http://localhost:5000"; 

// Props: onClose (fn), type ("JOB" or "PARTNERSHIP")
export default function JobApplicationForm({ onClose, type = "JOB" }) {
  const isJob = type === "JOB";

  // Form State
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [experience, setExperience] = useState("");
  const [qualification, setQualification] = useState("");
  const [file, setFile] = useState(null);

  // Dropdown Data
  const [rolesOptions, setRolesOptions] = useState([]);
  const [qualificationsOptions, setQualificationsOptions] = useState([]);
  
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  useEffect(() => {
    if (isJob) {
      fetch(`${API_URL}/public/options`)
        .then((res) => res.json())
        .then((data) => {
          setRolesOptions(data.roles || []);
          setQualificationsOptions(data.qualifications || []);
        })
        .catch(console.error);
    }
  }, [isJob]);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      if (selected.size > 5 * 1024 * 1024) {
        setMsg({ type: "error", text: "File size exceeds 5MB limit." });
        setFile(null);
        e.target.value = null; // Reset input
        return;
      }
      setFile(selected);
      setMsg({ type: "", text: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMsg({ type: "error", text: "Please upload a document." });
      return;
    }

    setSubmitting(true);
    setMsg({ type: "", text: "" });

    const formData = new FormData();
    formData.append("fullName", name);
    formData.append("email", email);
    
    // Append fields based on type
    if (isJob) {
        formData.append("role", role);
        formData.append("experience", experience);
        formData.append("qualification", qualification);
        formData.append("cv", file); // Field name expected by Multer
    } else {
        formData.append("proposal", file); // Field name for partnership
    }

    const endpoint = isJob ? "/public/apply" : "/public/partner";

    try {
      const res = await fetch(`${API_URL}${endpoint}`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();

      if (res.ok) {
        setMsg({ type: "success", text: data.message });
        // Clear form after success
        setTimeout(() => onClose(), 2000);
      } else {
        throw new Error(data.error || "Submission failed");
      }
    } catch (err) {
      setMsg({ type: "error", text: err.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-container">
      <button className="close-btn" onClick={onClose}>&times;</button>
      <h2>{isJob ? "Job Application" : "Partnership Proposal"}</h2>
      
      {msg.text && (
        <div style={{
            padding: "10px", 
            marginBottom: "15px", 
            borderRadius: "5px",
            background: msg.type === "error" ? "#fee" : "#efe",
            color: msg.type === "error" ? "#c00" : "#090"
        }}>
            {msg.text}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label className="field-label">
          {isJob ? "Full Name:" : "Organization / Contact Name:"}
          <input
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input-field"
          />
        </label>

        <label className="field-label">
          Email Address:
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-field"
          />
        </label>

        {isJob && (
          <>
            <label className="field-label">
              Role Applying For:
              <select
                required
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="input-field"
              >
                <option value="">— Select Position —</option>
                {rolesOptions.map((r, i) => <option key={i} value={r}>{r}</option>)}
              </select>
            </label>

            <label className="field-label">
              Years of Experience:
              <input
                type="number"
                min="0"
                required
                value={experience}
                onChange={(e) => setExperience(e.target.value)}
                className="input-field"
              />
            </label>

            <label className="field-label">
              Qualification:
              <select
                required
                value={qualification}
                onChange={(e) => setQualification(e.target.value)}
                className="input-field"
              >
                <option value="">— Select —</option>
                {qualificationsOptions.map((q, i) => <option key={i} value={q}>{q}</option>)}
              </select>
            </label>
          </>
        )}

        <label className="field-label">
          Upload {isJob ? "CV" : "Proposal"} (PDF/Word, Max 5MB):
          <input
            type="file"
            required
            accept=".pdf,.doc,.docx"
            onChange={handleFileChange}
            className="input-field"
          />
        </label>

        <button type="submit" className="submit-btn" disabled={submitting}>
          {submitting ? "Uploading..." : "Submit"}
        </button>
      </form>
    </div>
  );
}